var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#8247E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1477_5600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7915 19.8795C32.2442 19.5667 31.5406 19.5667 30.9152 19.8795L26.5371 22.4594L23.5662 24.1012L19.2663 26.6812C18.719 26.9939 18.0154 26.9939 17.3899 26.6812L14.0282 24.6485C13.4809 24.3357 13.09 23.7103 13.09 23.0067V19.0977C13.09 18.4722 13.4027 17.8468 14.0282 17.4559L17.3899 15.5014C17.9372 15.1886 18.6408 15.1886 19.2663 15.5014L22.628 17.534C23.1753 17.8468 23.5662 18.4722 23.5662 19.1758V21.7558L26.5371 20.0358V17.3777C26.5371 16.7522 26.2243 16.1268 25.5989 15.7359L19.3444 12.0614C18.7972 11.7487 18.0936 11.7487 17.4681 12.0614L11.0573 15.8141C10.4319 16.1268 10.1191 16.7522 10.1191 17.3777V24.7267C10.1191 25.3521 10.4319 25.9775 11.0573 26.3684L17.3899 30.0429C17.9372 30.3556 18.6408 30.3556 19.2663 30.0429L23.5662 27.5412L26.5371 25.8212L30.837 23.3194C31.3842 23.0067 32.0879 23.0067 32.7133 23.3194L36.0751 25.2739C36.6223 25.5866 37.0132 26.2121 37.0132 26.9157V30.8247C37.0132 31.4502 36.7005 32.0756 36.0751 32.4665L32.7915 34.421C32.2442 34.7338 31.5406 34.7338 30.9152 34.421L27.5534 32.4665C27.0061 32.1538 26.6152 31.5284 26.6152 30.8247V28.323L23.6444 30.0429V32.6229C23.6444 33.2483 23.9571 33.8738 24.5825 34.2647L30.9152 37.9392C31.4624 38.2519 32.166 38.2519 32.7915 37.9392L39.1241 34.2647C39.6714 33.952 40.0623 33.3265 40.0623 32.6229V25.1957C40.0623 24.5703 39.7496 23.9448 39.1241 23.5539L32.7915 19.8795Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1477_5600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.0213,
    height: 26.1905,
    fill: "white",
    transform: "translate(10.1191 11.9048)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.1b9ab6fa703de8fae0c9004e0cef2060.svg";
export { ForwardRef as ReactComponent };